import { h } from 'preact';
import { accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import * as BaseComp from 'base/showtimes/showtimesApp.js';
import SignupBanner from 'components/shared/signupBanner/signupBanner';
import Store from 'store/store';
import * as actions from 'store/actions';
import qs from 'qs';

const LOCAL_BASE_URL = 'http://localhost:4010/preview/nationaltheatrelive/nt-live-hub/gb/local/';
const DEMO_BASE_URL = 'http://demo.showtimes-static.s3-website-eu-west-1.amazonaws.com/nationaltheatrelive/nt-live-hub/gb/';
const STAGE_BASE_URL = 'http://stage.showtimes-static.s3-website-eu-west-1.amazonaws.com/nationaltheatrelive/nt-live-hub/gb/';
const PROD_BASE_URL = 'https://www.ntlive.com/';

export default class ShowtimesApp extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state.showBanner = false;

		this.showBanner  = this.showBanner.bind(this);
		this.closeBanner = this.closeBanner.bind(this);
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeout);
		window.removeEventListener('resize', this.handleResize)
		Store.off(actions.SET_ACTIVE_PAGE, this.scrollToTop);
	}

	componentDidMount() {
		super.componentDidMount();

		const ua = navigator.userAgent || '';
		const isIE = ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1;

		if (isIE) {
			let baseURL = PROD_BASE_URL;
			if (__IS_LOCAL__) baseURL = LOCAL_BASE_URL;
			if (__IS_DEMO__) baseURL = DEMO_BASE_URL;
			if (window.location.href.includes('stage.showtimes-static.s3-website-eu-west-1.amazonaws.com')) baseURL = STAGE_BASE_URL;

			location.href = `${baseURL}browser-not-supported.html`;
		}

		this.scrollToTop();
		Store.on(actions.SET_ACTIVE_PAGE, this.scrollToTop);

		const cookiePresent = document.cookie.split('; ').find(row => row.startsWith('signupBannerSeen'));
		const query = qs.parse(window.location.search.substring(1));
		const showBanner = query.utm_source !== 'SilverpopMailing';

		this.handleResize();
		window.addEventListener('resize', this.handleResize);

		if (cookiePresent || !showBanner) {
			return;
		}

		this.timeout = window.setTimeout(() => {
			this.showBanner();
		}, 20000);

	}

	scrollToTop(page, scrollToSection) {
		const duration = scrollToSection ? 500 : 0;
		const delay = 500;
		setTimeout(() => {
			const target = scrollToSection ? document.getElementById(scrollToSection) : 0;
			smoothScrollTo('root', target, duration, { force: true });
		}, delay);
	}

	lockScroll(lock) {
		let overflow = lock ? 'hidden' : '';
		document.body.style.overflow = overflow;
	}

	handleResize() {
		const windowHeight = window.innerHeight;
		document.documentElement.style.setProperty('--window-height', windowHeight + 'px');
	}

	showBanner() {
		this.setState({ showBanner: true });
	}

	closeBanner() {
		this.setState({ showBanner: false });
	}

	getExtra() {
		const { showBanner } = this.state;
		const data = accessNested(this.state, 'appState.appData.footer.signup');
		const client = accessNested(this.state, 'appState.client');

		return <SignupBanner data={data} close={this.closeBanner} show={showBanner} client={client} />;
	}
}
